import styled from 'styled-components/native'

// Copied from screens/dataExtraction/QueueTable rather than imported: that file
// is a queue-specific screen component, and messageLog reaching into it for
// these primitives is a wart worth not spreading. If a third screen needs them
// they belong in components/common.

export const TableContainer = styled.View`
  flex: 1;
  padding: 10px;
  background-color: ${props => props.theme.colors.primary};
  border-radius: 8px;
`

// flex-shrink: 0 is load-bearing. Rows sit inside scroll areas, and a row that
// is allowed to shrink is compressed below its content height once the list
// overflows -- text from adjacent rows overlaps and fixed-height thumbnails
// spill into their neighbours.
export const TableRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 8px;
  background-color: ${props => props.theme.colors.appBackground};
  border-bottom-width: 1px;
  border-bottom-color: ${props => props.theme.colors.lightGrey};
  align-items: center;
`

export const TableHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 8px;
  background-color: ${props => props.theme.colors.appBackground};
  border-bottom-width: 1px;
  border-bottom-color: ${props => props.theme.colors.lightGrey};
`

export const TableCol = styled.View`
  flex: 1;
  min-width: 100px;
`
